module.exports = __webpack_public_path__ + "static/media/slack.715ff720.svg";